// extracted by mini-css-extract-plugin
export default {"table":"styles_table__WmXWN","tables":"styles_tables__1bNnI"};